<template>
  <!-- 中软烟草 -->
  <div class="wrap">
    <Spin fix class="ivu-spin-fullscreen" :class="{'dt-none': isLoading === false }">
      <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
      <div>{{loadingText}}</div>
    </Spin>
    <div class="map-layout">
      <header class="head-style">
        <span class="title-cont title-style bold">拜访客户数</span>
        <span class="title-cont title-style">{{orderCust}}个</span>
        <span class="title-cont title-style bold">预计行程</span>
        <span class="title-cont title-style">{{totalKm}}km</span>
        <span class="title-cont title-style bold">总重量</span>
        <span class="title-cont title-style">{{totalWeitht}}kg</span>
        <span class="title-cont title-style bold" style="clear: left">预计时长</span>
        <span class="title-cont title-style">{{totalTime}}min</span>
        <span class="title-cont title-style bold">预计开始时间</span>
        <span class="title-cont title-style">{{startTime}}</span>
        <span class="title-cont title-style bold">预计结束时间</span>
        <span class="title-cont title-style">{{endTime}}</span>
        <Button type="primary" class="btn-table" @click="clickShowTab">{{shoTabName}}</Button>
      </header>
      <div class="right">
        <div class="visit-panel">
          <div class="select-user-panel select-condition">
            <div class="select-user-block">
              <span class="select-user-title">城市</span>
              <Select
                v-model="citySlect"
                class="select-user text-center margin-top-10"
                @on-change="changeCity(citySlect)"
              >
                <Option
                  v-for="city in cities"
                  :key="city.value"
                  :value="city.value"
                >{{ city.label }}</Option>
              </Select>
            </div>
            <div class="select-user-block">
              <span class="select-user-title">车辆</span>
              <Select
                v-model="userSelect"
                class="select-user text-center margin-top-10"
                :label-in-value="true"
                @on-change="changCar"
              >
                <Option
                  v-for="user in userAlls"
                  :key="user.label"
                  :value="user.value"
                >{{ user.label }}</Option>
              </Select>
            </div>
          </div>
          <div id="calendar" class="margin-top-8"></div>
          <div class="current-month-num current-month-heitht">
            <p class="title">统计详情</p>
            <div class="current-month-num-body">
              <div class="all-line-info font-bold">
                <span class="with-50">拜访用户数量</span>
                <span>{{orderCust}}</span>个
              </div>
              <Col class="all-line-info font-bold">
                <span class="with-50">预计总行程</span>
                <span>{{totalKm}}km</span>
              </Col>
              <Col class="all-line-info font-bold">
                <span class="with-50">预计总时长</span>
                <span>{{totalTime}}min</span>
              </Col>
            </div>
          </div>
          <div v-show="false" class="future-visit-panel height-295">
            <p class="title">未排入本月PJP的客户（{{futureVisit.length}}）</p>
            <div class="future-visit-panel-body">
              <div class="visit-item" v-for="visit in futureVisit">
                <Col span="12" class="visit-custorm">{{visit.attrs.CustomerName}}</Col>
                <Col span="12" class="add-daily" style="text-align:right;">
                  <span>+</span>
                  加入日程
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left" ref="mapPanel">
        <Table v-show="showTable" :columns="tableTitle" :data="tableItems" class="table-style"></Table>
        <div id="mapContainer" class="map-style"></div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import CreateDate from "./CreateDate.vue";
import "../assets/stylesheets/map_demo.scss";
import "../assets/stylesheets/calendar.css";
import "../assets/javascript/jquery.min.js";
import "../assets/javascript/calendal.js";
import api from "../service/api";
import getData from "../service/getData";
import getColor from "../service/randomColor.js";
import { setTimeout } from "timers";
import io from "socket.io-client";
import config from "../../config/config.js";
import moment from "moment";
import demoUser from "../data/demoUser.js";
import {
  initMap,
  openMarWindow,
  openLineWindow
} from "../assets/javascript/map.js";
import { throws } from "assert";

export default {
  data: function() {
    return {
      isLoading: false,
      loadingText: "加载中...",
      today: "",
      orderCust: 0,
      totalKm: "0",
      totalWeitht: "0",
      totalTime: "0",
      startTime: "00:00",
      endTime: "00:00",
      citySlect: "合肥",
      cities: [
        {
          value: "合肥",
          label: "合肥"
        }
      ],
      tableTitle: [
        {
          title: "id",
          key: "id",
          width: 130
        },
        {
          title: "到达时间",
          key: "arriveTime",
          width: 90
        },
        {
          title: "停留时间",
          key: "visitDuration",
          width: 90
        },
        {
          title: "重量",
          key: "weight",
          width: 60
        },
        {
          title: "城市",
          key: "City",
          width: 90
        },
        {
          title: "地址",
          key: "adress",
          width: 90
        }
      ],
      tableItems: [],
      userSelect: -1,
      userAlls: [
        {
          value: -1,
          label: "全部"
        }
      ],
      users: [],
      custCount: 0, //全部的客户数
      visitDistance: 0,
      visitDurction: 0,
      visitDays: 0,
      restDays: 0,
      futureVisit: [],
      layerGroup: new L.layerGroup(),
      layerMap: new Map(), //用来存储现在显示的
      showTable: false,
      shoTabName: "展示列表",
      pointsMap: new Map(), //保存全部的客户
      carInfoMap: new Map() //每辆车的统计详情
    };
  },
  computed: {},
  mounted() {
    this.map = initMap(); //初始化地图
    this.layerGroup.addTo(this.map);
    this.getFileData();
  },
  methods: {
    getFileData: async function() {
      const res = await getData.get(api.getFileData, {
        // fileName: "中软烟草排线"
        fileName: "中软烟草排线~返回"
      });
      if (res.data && res.data.status) {
        for (const point of res.data.info.points_all) {
          this.pointsMap.set(point.id, point);
        }
        this.drawLine(res.data.info.line_info);
      }
      const self = this;
      const dates = [];
      $("#calendar").calendar({
        ifSwitch: true, // 是否切换月份
        hoverDate: false, // hover是否显示当天信息
        backToday: false, // 是否返回当天
        selected_data: self.today.replace(/-/g, ""),
        dates,
        afterInit: function(today) {
          if (today) {
            self.today = today;
          }
          // self.getDayInfo(getDate ? getDate : self.today); //设置当天点线
          // self.setDayInfo(getDate ? getDate : self.today); //展示当天基本信息
        },
        onMonthChange: function(date) {},
        onClick: function(today, selectDay) {
          self.today = selectDay;
          self.getDayInfo(selectDay);
          self.setDayInfo(selectDay);
        }
      });
    },
    drawLine: function(lineInfo) {
      const allMarkerLayers = []; //只有展示全部的时候才显示
      for (let lineIndex = 0; lineIndex < lineInfo.length; lineIndex++) {
        this.userAlls.push({
          value: lineIndex,
          label: `车辆${ lineIndex}`
        });
        const linfo = lineInfo[lineIndex]; //单个车辆的线路详情
        const layers = []; //同一辆车的电线图层

        const color = getColor.getColor(); //每辆车一个颜色


        const carInfo = {
          orderNum: linfo.route_info.length - 2,
          totalDis: (linfo.distance / 1000).toFixed(2),
          totalWeight: 0,
          totalDurciton: linfo.durction.toFixed(2),
          beginTime: "08:00",
          endTime: moment("08:00", "HH:mm")
            .add(linfo.durction.toFixed(2), "m")
            .format("HH:mm"),
          tableItems: []
        };

        for (let index = 0; index < linfo.route_info.length; index++) {
          const pointId = linfo.point_ids[index];
          const point = this.pointsMap.get(pointId);
          const route = linfo.route_info[index];

          if (point.weight) carInfo.totalWeight += parseInt(point.weight);

          carInfo.tableItems.push({
            id: point.id,
            arriveTime: route.time,
            visitDuration: "2分钟",
            weight: point.weight ? point.weight : "-" + "kg",
            City: point.City ? point.City : "合肥",
            adress: point.address ? point.address : ""
          });

          // 画点
          const divHtml = `<div class='way-points' style='background-color:${color}'>${index +
            1}</div>`;
          const wayDivIcon = new L.divIcon({
            html: divHtml,
            className: "leaflet-direction-icon"
          });
          const marPups = [
            {
              name: "id",
              cont: point.orderId
            },
            {
              name: "停留时间",
              cont: "2分钟"
            },
            {
              name: "到达时间",
              cont: route.time
            },
            {
              name: "重量",
              cont: point.weight
            },
            {
              name: "车辆",
              cont: `车辆${ lineIndex}`
            }
          ];
          allMarkerLayers.push(
            L.circleMarker([point.lat, point.lng], {
              radius: 3,
              color: color
            }).on("click", function marClik(e) {
              openMarWindow(e, marPups);
            })
          );

          layers.push(
            L.marker([point.lat, point.lng], {
              icon: wayDivIcon
            }).on("click", function marClik(e) {
              openMarWindow(e, marPups);
            })
          );
          // 划线
          if (route.path === "") continue;
          const attrRoutes = [
            {
              name: "距离",
              cont: `${(route.distance / 1000).toFixed(2) }千米`
            },
            {
              name: "时间",
              cont: `${route.durction.toFixed(2) }分钟`
            }
          ];

          const latLngs = [];
          const routes = route.path.split(";");
          for (let route of routes) {
            latLngs.push(route.split(",").reverse());
          }
          layers.push(
            L.polyline(latLngs, {
              color: color
            }).on("click", function marClik(e) {
              openLineWindow(e, attrRoutes);
            })
          );
        }
        const featureGroup = L.featureGroup(layers);
        this.layerMap.set(lineIndex, featureGroup);
        this.carInfoMap.set(lineIndex, carInfo);
      }
      const allCircGroup = L.featureGroup(allMarkerLayers);
      this.layerMap.set(-1, allCircGroup);
      this.changCar({ value: -1 });
    },
    changCar: async function(indexCar) {
      for (let layersGroup of this.layerMap.values()) {
        layersGroup.remove();
      }
      if (this.layerMap.has(indexCar.value)) {
        this.layerMap.get(indexCar.value).addTo(this.map);
        this.map.fitBounds(this.layerMap.get(indexCar.value).getBounds());
      }
      const carInfo = this.carInfoMap.get(indexCar.value);

      this.totalKm = carInfo ? carInfo.totalDis : 0;

      this.totalTime = carInfo ? carInfo.totalDurciton : "8*60";
      this.startTime = carInfo ? carInfo.beginTime : "08:00";
      this.endTime = carInfo ? carInfo.endTime : "16:00";

      if (carInfo) {
        this.totalWeitht = carInfo.totalWeight;
        this.orderCust = carInfo.orderNum;
        this.tableItems = carInfo.tableItems;
      } else {
        this.totalWeitht = 147098;
        this.orderCust = 3509;
        const allCarinfos = [...this.carInfoMap.values()];
        let alltableItems = [];
        // for (const cinfo of allCarinfos) {
        //   alltableItems = alltableItems.concat(cinfo.tableItems);
        // }
        this.tableItems = alltableItems;
      }
    },
    clickShowTab: function() {
      this.showTable = !this.showTable;
      this.shoTabName =
        this.shoTabName === "展示列表" ? "隐藏列表" : "展示列表";
    }
  }
};
</script>
<style lang="less">
.map-layout .with-all-8 {
  width: calc(~"100% - 8px");
}
.wrap {
  height: 100%;
  position: relative;
}
.height-200 {
  height: 230px !important;
}
.all-line-info {
  text-align: left;
  font-size: 10px;
  margin: 4px;
}
.font-bold {
  font-weight: bold;
  font-size: 12px !important;
}
.bold {
  font-weight: bold;
}
.with-50 {
  display: inline-block;
  width: 90px;
}
.title-style {
  width: 100px;
  text-align: left;
}
.map-layout .left .ivu-table-wrapper.table-style {
  width: 566px;
}
.table-style {
  .ivu-table {
    .ivu-table-overflowX {
      overflow-x: hidden;
    }
    overflow-x: hidden;
    overflow-y: auto !important;
  }
}

.head-style {
  width: calc(~"100% - 436px");
  float: left;
  height: 60px;
  border-bottom: 1px solid #c9d3e0;
  padding-top: 8px;
  padding-left: 16px;
}
.select-condition {
  margin-top: 0 !important;
  height: 52px !important;
  line-height: 52px !important;
}
.margin-top-10 {
  margin-top: 10px !important;
}
.margin-top-8 {
  margin-top: 8px;
}
.float-left {
  float: left;
}
.btn-table {
  float: right;
  margin-top: -16px;
}
.title-cont {
  height: 22px;
  line-height: 22px;
  float: left;
  color: #576d8b;
  font-size: 14px;
}
.current-month-heitht {
  height: calc(~"100% - 55px") !important;
}
.height-295 {
  height: calc(~"100% - 295px") !important;
}

.way-points{
    width: 30px;
    height: 30px;
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/DemoZr.vue